import EligibleList from '@/ev-tax-credit/EvEligibilty/EligibleList';
import AreYouQualified from './AreYouQualified';
import HowVehiclesQualify from './HowVehiclesQualify';

export default function EvEligibility() {
  return (
    <div className="mx-auto flex  max-w-[1056px] flex-col px-2xl pb-2xl pt-6xl sm:px-3xl sm:pb-4xl md:pt-8xl">
      <img
        src={`${process.env.CVNA_APP_CDN_ASSETS_PATH}/images/ev-eligibility.png`}
        alt="A family loading their EV for a trip"
        className="w-full max-w-[1056px]"
      />
      <AreYouQualified />
      <HowVehiclesQualify />
      <EligibleList />
    </div>
  );
}
